import API from '../../../services/API';
import { setError, startSpinner, stopSpinner } from '../../common/actionCreators';
import { ELIGIBILITY_RESULTS_ACTION_TYPES } from '../../../constants/actionTypes/eligibilityResultsActionTypes';

export const setEligibilityResults = eligibilityResults => ({
    type: ELIGIBILITY_RESULTS_ACTION_TYPES.SET_ELIGIBILITY_RESULTS,
    eligibilityResults
});

/************************

 # Async action creators

 ************************/

const actions = { setError, startSpinner, stopSpinner };

export const fetchEligibilityResults = url => async (dispatch, getState) => {
    const data = await API.getData(url, dispatch, actions, true, getState());
    if (data) {
        dispatch(setEligibilityResults(data));
        return data;
    } else {
        console.error('Cannot fetchEligibilityResults', url);
    }
};

/************************

 # POST calls

 ************************/

export const postFullDetermination = (...args) => async dispatch => {
    const data = await API.postData(args, dispatch, actions);

    if (data) {
        return data;
    } else {
        console.error('Cannot requestFullDetermination');
    }
};

export const saveSeekQHPChanges = (...args) => async dispatch => {
    const data = await API.postData(args, dispatch, actions);

    if (data) {
        return data;
    } else {
        console.error('Cannot saveSeekQHPChanges');
    }
};

export const setFullDetermination = (...args) => async dispatch => {
    const data = await API.postData(args, dispatch, actions);

    if (data) {
        return data;
    } else {
        console.error('Cannot setFullDetermination');
    }
};